/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ApiBaseService } from '../api-base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { GetChatResult } from '../models/get-chat-result';
import { getChats } from '../fn/chats/get-chats';
import { GetChats$Params } from '../fn/chats/get-chats';
import { getChatsByChatid } from '../fn/chats/get-chats-by-chatid';
import { GetChatsByChatid$Params } from '../fn/chats/get-chats-by-chatid';
import { GetChatsResult } from '../models/get-chats-result';
import { GetUnreadChatsCountResult } from '../models/get-unread-chats-count-result';
import { getUnreadCount } from '../fn/chats/get-unread-count';
import { GetUnreadCount$Params } from '../fn/chats/get-unread-count';
import { postReply } from '../fn/chats/post-reply';
import { PostReply$Params } from '../fn/chats/post-reply';
import { postSetAsRead } from '../fn/chats/post-set-as-read';
import { PostSetAsRead$Params } from '../fn/chats/post-set-as-read';
import { ReplyToChatResponse } from '../models/reply-to-chat-response';

@Injectable({ providedIn: 'root' })
export class ApiChatsService extends ApiBaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getChatsChatsByChatid()` */
  static readonly GetChatsChatsByChatidPath = '/Chats/chats/{ChatId}';

  /**
   * get-chats-chats-by-chatid.
   *
   * Get chat by id<br>Get chat by id
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getChatsByChatid()` instead.
   *
   * This method doesn't expect any request body.
   */
  getChatsByChatid$Response(params: GetChatsByChatid$Params, context?: HttpContext): Observable<StrictHttpResponse<GetChatResult>> {
    return getChatsByChatid(this.http, this.rootUrl, params, context);
  }

  /**
   * get-chats-chats-by-chatid.
   *
   * Get chat by id<br>Get chat by id
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getChatsByChatid$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getChatsByChatid(params: GetChatsByChatid$Params, context?: HttpContext): Observable<GetChatResult> {
    return this.getChatsByChatid$Response(params, context).pipe(map((r: StrictHttpResponse<GetChatResult>): GetChatResult => r.body));
  }

  /** Path part for operation `getChats()` */
  static readonly GetChatsPath = '/Chats';

  /**
   * get-chats.
   *
   * Get chats by conviveId<br>Get chats for a conviveId
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getChats()` instead.
   *
   * This method doesn't expect any request body.
   */
  getChats$Response(params?: GetChats$Params, context?: HttpContext): Observable<StrictHttpResponse<GetChatsResult>> {
    return getChats(this.http, this.rootUrl, params, context);
  }

  /**
   * get-chats.
   *
   * Get chats by conviveId<br>Get chats for a conviveId
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getChats$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getChats(params?: GetChats$Params, context?: HttpContext): Observable<GetChatsResult> {
    return this.getChats$Response(params, context).pipe(map((r: StrictHttpResponse<GetChatsResult>): GetChatsResult => r.body));
  }

  /** Path part for operation `getChatsUnreadCount()` */
  static readonly GetChatsUnreadCountPath = '/Chats/unread-count';

  /**
   * get-chats-unread-count.
   *
   * Get unread chats count<br>Get all unread chats for authenticated user
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUnreadCount()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUnreadCount$Response(params?: GetUnreadCount$Params, context?: HttpContext): Observable<StrictHttpResponse<GetUnreadChatsCountResult>> {
    return getUnreadCount(this.http, this.rootUrl, params, context);
  }

  /**
   * get-chats-unread-count.
   *
   * Get unread chats count<br>Get all unread chats for authenticated user
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getUnreadCount$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUnreadCount(params?: GetUnreadCount$Params, context?: HttpContext): Observable<GetUnreadChatsCountResult> {
    return this.getUnreadCount$Response(params, context).pipe(map((r: StrictHttpResponse<GetUnreadChatsCountResult>): GetUnreadChatsCountResult => r.body));
  }

  /** Path part for operation `postChatsReply()` */
  static readonly PostChatsReplyPath = '/Chats/reply';

  /**
   * post-chats-reply.
   *
   * Reply to Chat
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postReply()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postReply$Response(params?: PostReply$Params, context?: HttpContext): Observable<StrictHttpResponse<ReplyToChatResponse>> {
    return postReply(this.http, this.rootUrl, params, context);
  }

  /**
   * post-chats-reply.
   *
   * Reply to Chat
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postReply$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postReply(params?: PostReply$Params, context?: HttpContext): Observable<ReplyToChatResponse> {
    return this.postReply$Response(params, context).pipe(map((r: StrictHttpResponse<ReplyToChatResponse>): ReplyToChatResponse => r.body));
  }

  /** Path part for operation `postChatsSetAsRead()` */
  static readonly PostChatsSetAsReadPath = '/Chats/set-as-read';

  /**
   * post-chats-set-as-read.
   *
   * Set Chats as read<br>
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postSetAsRead()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postSetAsRead$Response(params?: PostSetAsRead$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return postSetAsRead(this.http, this.rootUrl, params, context);
  }

  /**
   * post-chats-set-as-read.
   *
   * Set Chats as read<br>
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postSetAsRead$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postSetAsRead(params?: PostSetAsRead$Params, context?: HttpContext): Observable<void> {
    return this.postSetAsRead$Response(params, context).pipe(map((r: StrictHttpResponse<void>): void => r.body));
  }
}
